import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { PengaturanPlatform } from '../../components/PengaturanPlatform'
import { useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/pengaturan')({
  component: PengaturanPage,
})

function PengaturanPage() {
  const { data: session } = useSession()
  const logout = useLogout()
  const user = session?.user

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <PengaturanPlatform />
    </AppShell>
  )
}
